import { Context } from "../../lib/context";
export class ToolbarContext extends Context {
    constructor(map) {
        super(map);
        this.name = 'toolbar';
        this.has_measure = true;
        this.exit_contexts = ['singleton', 'set', 'selection', 'group', 'edit'];
    }
    on_enter() { }
    on_exit() { }
    zoom() { }
    async click_handler(_, __) {
        return;
    }
}
